var React = require('react');
var BaseComponent = require('../../../../../../views/shared/base');
let TableInvoicesComponent = require('../../../../../custom/orders/tableinvoices.jsx');
const client = require('../../../../../../../sdk/client');
class ShippingPaymentDetailComponent extends BaseComponent {
    constructor(props){
		super(props);
		this.state = {
            visible : true
        }
        this.componentRendered = false;
	}
    getLatestOrderStatus(cartItem) {
        //let status = "";
        //let fulfilmentStatus = cartItem.Statuses.filter(s => s.Type === 'Fulfilment');
        //if (fulfilmentStatus.length > 0) {
        //    status = fulfilmentStatus[fulfilmentStatus.length - 1].Name;
        //} else if (fulfilmentStatus.length === 0) {
        //    let orderStatus = cartItem.Statuses.filter(s => s.Type === 'Order');
        //    if (orderStatus.length > 0) {
        //        status = orderStatus[orderStatus.length - 1].Name;
        //    }
        //}
        //b2b
        let status = "";

        let orderStatuses = cartItem.Statuses.filter(s => s.Type === 'Order');

        if (process.env.CHECKOUT_FLOW_TYPE === 'b2c') {
            orderStatuses = cartItem.Statuses.filter(s => s.Type === 'Fulfilment');
        }

        if (orderStatuses.length > 0) {
            orderStatuses.sort((a, b) => (a.CreatedDateTime > b.CreatedDateTime) ? 1 : -1)
            status = orderStatuses[orderStatuses.length - 1].Name;
        } else if (orderStatuses.length === 0) {
            let fulfillmentStatuses = cartItem.Statuses.filter(s => s.Type === 'Fulfilment');
            if (fulfillmentStatuses.length > 0) {
                status = fulfillmentStatuses[fulfillmentStatuses.length - 1].Name;
            }
        } 
        switch (status) {
            case 'Acknowledged':
                status = 'Recibido';
                break;
            case 'Collected':
                status = 'Fincado';
                break;
            case 'Delivered':
                /*
                ??
                if (cartItem.BookingSlot != 'undefined') {
                    status = 'Enviado';
                }*/
                status = 'En Surtimiento';
                break;
            case 'Completed':
                status = 'Facturado';
                break;
            case 'Cancelled':
                status = 'Cancelado';
                break;
            case 'Created':
                status = 'Recibido';
                break;
            /*
            This case status doesn't work, it never updates his status
                case 'Ready For Consumer Collection':
                status = 'Facturado';
                break;
            */
        }
        return status;
        //return status === 'Ready For Consumer Collection' ? 'Ready for Pick-up' : status;
    }

    componentDidMount() {
        //TODO: POGI GO BACK HERE IN MONDAY
        var self = this;
        if(this.componentRendered) {
            this.getOrderCustomTableDetails();
        }
    }

    componentWillUnmount() {
        this.componentRendered = false
    }

    getOrderCustomTableDetails() {
        var self = this;
		var options = {
			pluginId : process.env.OPENPAY,
			tableName : "SucceedRegisteredOrders",
			query: [
				{
					"Name": "PurchaseOrder",
					"Operator": "eq",
					"Value": this.props.detail.Orders[0].PurchaseOrderNo
				}
			]
		}
		client.CustomTables.searchCustomTable(options, (err, response) => {
            if(response.TotalRecords > 0) {
                var status = response.Records[0].Status;
                if(status == "Cotizacion creada" || status == "Cotizacion" || status == "Cotizacion enviada"){
                    var addedText = "Cotización Recibida";
                    if(status == "Cotizacion creada" || status == "Cotizacion"){
                        addedText = "Cotización en espera de envío"
                    }
                    self.setState({
                        visible: false
                    },() => {
                        $('#order-status-lbl').text(`Estatus de orden: ${addedText}`);
                    });
                }
            }
		});
	}

    showTableInvoicePopUp(){
        document.getElementById("invoiceTable").style.display = "block";
    }

    render() {
        const detail = this.props.detail;
        const order = detail.Orders[0];

        let shippingMethod = '';
        let shippingMethodMinimumLeadTime = 'N/A';
        let shippingMethodID = null;
        const cartItem = order.CartItemDetails[0];

        if (cartItem.PickupAddress) {
            shippingMethod = cartItem.PickupAddress.Line1;
        } else if (cartItem.ShippingMethod) {
            shippingMethod = cartItem.ShippingMethod.Description;
            shippingMethodID = cartItem.ShippingMethod.ID;
        }

        if (cartItem.ShippingMethod && cartItem.ShippingMethod.CustomFields) {
            var customFieldValue = JSON.parse(cartItem.ShippingMethod.CustomFields[0].Values[0]);
            shippingMethodMinimumLeadTime = customFieldValue.MinimumLeadTime;
        }

        let orderNo = "-";
        if (order.PurchaseOrderNo) {
            orderNo = order.CosmeticNo != null && order.CosmeticNo != "" ? order.CosmeticNo : order.PurchaseOrderNo;
        }

        let paymentStatusTableBase = order.PaymentStatus || '';

        var arrStrOrdersIDs = "";
        if (
            order.CustomFields != undefined
            )
        {
            var ordersLiderIds = order.CustomFields.find(x => x.Name == process.env.LIDER_ORDER_IDS);
            if(ordersLiderIds !== null && ordersLiderIds !== undefined){
                if(ordersLiderIds.Values.length > 0 && ordersLiderIds.Values[0] !== ""){
                    arrStrOrdersIDs =  ordersLiderIds.Values[0]
                }
            }
        }

        switch(paymentStatusTableBase) {
            case "Processing":
                paymentStatusTableBase = "Procesando";
                break;
            case "Pending Paid":
                paymentStatusTableBase = "Pago Pendiente";
                break;
            case "Failed":
                paymentStatusTableBase = "Fallido";
                break;
            case "Refunded":
                paymentStatusTableBase = "Reintegrado";
                break;
            case "Acknowledged":
                paymentStatusTableBase = "Aceptado";
                break;
            case "Waiting For Payment":
                paymentStatusTableBase = "A la espera del Pago";
                break;
            case "Paid":
                paymentStatusTableBase = "Pagado";
                break;
        }

        //if (order.PaymentDetails != null && order.PaymentDetails.length > 0) {
        //    paymentStatusTableBase = order.PaymentDetails[0].Status == "Success" ? 'Paid' : order.PaymentDetails[0].Status
        //}

        let orderStatus = "N / A"

        if(this.getLatestOrderStatus(cartItem)){
            switch(this.getLatestOrderStatus(cartItem)){
                case "Delivered":
                    orderStatus = "Entregado";
                    break;
                case "Acknowledged":
                    orderStatus = "Aceptado";
                    break; 
                case "Collected":
                    orderStatus = "Recogido";
                    break;
                case "Ready For Consumer Collection":
                    orderStatus = "Listo para la colección del consumidor";
                    break;
                default:
                    orderStatus = this.getLatestOrderStatus(cartItem);
            }
        }

        var displayOption = "block";
        if(!this.state.visible){
            displayOption = "none";
        }
        this.componentRendered = true;
        return (
            <div className="col-md-4">
                <table className="canon-table table-details-order">
                    <tbody>
                        <tr>
                            <th className="OD-tittle-subsection">Detalles del pedido</th>
                        </tr>
                        <tr>
                        <td data-th="Invoice No. :">Pedido: {orderNo}</td>
                        </tr>
                        <tr>
                            <td data-th="Invoice No. :">Referencia: {order.PaymentDetails[0].CosmeticNo != null && order.PaymentDetails[0].CosmeticNo != "" ? order.PaymentDetails[0].CosmeticNo : detail.InvoiceNo}</td>
                        </tr>
                        <tr>
                            <td data-th="Invoice No. :">Id(s) de referencia: {arrStrOrdersIDs}</td>
                        </tr>
                        <tr>
                            <td style={{display : displayOption}} data-th="Invoice No. :">Tipo de pago: {order.PaymentDetails[0].Gateway ? order.PaymentDetails[0].Gateway.Gateway : "N / A"}</td>
                        </tr>
                        <tr className={order.PaymentDetails[0].Gateway != undefined && order.PaymentDetails[0].Gateway.Gateway == "Línea de crédito" ? "hide":""}>
                            <td style={{display : displayOption}} data-th="Invoice No. :">Estatus de pago: {paymentStatusTableBase}</td>
                        </tr>
                        <tr>
                            <td data-th="Invoice No. :">Método de envío: {shippingMethod}</td>
                        </tr>
                        {/*
                        This will be implemented in the next iteration of the proyecto, do not delete.
                        <tr>
                            <td data-th="Invoice No. :">Plazo de entrega mínimo: {shippingMethodMinimumLeadTime}</td>
                        </tr>
                        */}
                        <tr>
                            <td id='order-status-lbl' data-th="Invoice No. :">Estatus de orden: {orderStatus}</td>
                        </tr>
                    </tbody></table>
            </div>
        );
       
    }
}

module.exports = ShippingPaymentDetailComponent;

